<template>
  <div>
    <RouteHeader :name="name" :routeId="routeId" />
    <v-container fluid>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import RouteHeader from "@/modules/routes/components/RouteHeader";
export default {
  components: {
    RouteHeader,
  },
  computed: {
    name() {
      const active = this.$store.getters["RouteStore/cache"];
      if (!active) return "";
      if (active.label) return active.label;
      if (active.city_start && active.city_end) {
        return `${active.city_start} - ${active.city_end}`;
      }
      return "";
    },
    routeId() {
      return this.$store.getters["RouteStore/id"];
    },
  },
  mounted() {
    const routeId = this.$route.params.id;
    this.$store.dispatch("RouteStore/getOneRoute", routeId).catch((err) => this.$root.$error(err));
  },
};
</script>
